<script>
    import {SendRequest, ReleaseMode, PostRequestWithBody} from "./APIService";
    import moment from 'moment';
    import {showModal} from "./Modal";


    let allPublicNews = [];

    let publicNewsToCreate = {
        Data : {},
        ExpireAt : new Date()
    };

    let newsTypes = [
        ["Update", 0],
        ["UnderConstruction", 1],
        ["Custom", 2],
        ["SocialMedia", 3]
    ];

    let newsTypesWithTitleAndDescription = [
        findTypeById(0),
        findTypeById(1),
        findTypeById(2),
        findTypeById(3)
    ]

    let newsPriority = [
        ["High", 0],
        ["Low", 1],
    ];

    function findTypeById(id){
        for (let i = 0; i < newsTypes.length; i++) {
            if (newsTypes[i][1] == id)
                return newsTypes[i][0];
        }
    }

    function findPriorityById(id){
        for (let i = 0; i < newsPriority.length; i++) {
            if (newsPriority[i][1] == id)
                return newsPriority[i][0];
        }
    }



    function getAllPublicNews(){
        SendRequest(
            "GetAllPublicNews",
            "GET",
            "",
            (response) => {
                console.log("get all news Called");
                allPublicNews = response;
            },
            (error) => {
                showModal("Error", "failed to get public news", "OK");
                allPublicNews = [];
            }
        );
    }

    function createPublicNews(){

        // convert time to UTC
        var date = new Date(publicNewsToCreate.ExpireAt);
        var now_utc = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(),
            date.getUTCDate(), date.getUTCHours(),
            date.getUTCMinutes(), date.getUTCSeconds());

        publicNewsToCreate.ExpireAt = new Date(now_utc);

        PostRequestWithBody(
            "CreatePublicNews",
            "POST",
            publicNewsToCreate,
            (response) => {
                console.log("public news created");
                publicNewsToCreate = { Data : {}, ExpireAt : new Date() };
                getAllPublicNews();
            },
            (error) => {
                showModal("Error", "failed to create public news", "OK");
            }
        );
    }

    function deletePublicNews(id){
        SendRequest(
            "DeletePublicNews",
            "POST",
            "id=" + id,
            (response) => {
                console.log("public news deleted");
                allPublicNews = allPublicNews.filter(function (news){
                    news.id != id;
                })
                getAllPublicNews();
            },
            (error) => {
                showModal("Error", "failed to delete public news", "OK");
            }
        );
    }

    function onKeyDown(e){
        switch(e.keyCode) {
            case 13:
                getAllPublicNews()
                break;
        }
    }


    $: getAllPublicNews()


</script>

<br>
<br>
<br>

    <div class="row justify-content-md-center">
        <div class="card col-md-8">
            <div class="card-header">
                <h5 class="card-header" style="text-align: center;"><h3>Public News</h3></h5>
            </div>
            <div class="card-body">
                <div class="mb-3 row">
                    <button class="btn btn-outline-primary" type="button" on:click={getAllPublicNews}>Reload</button>
                </div>
            </div>
            <div class="card-body">
                {#if allPublicNews.length > 0 }
                <table class="table table-bordered table-hover">
                    <thead>
                    <tr>
                        <th style="width: 100px" scope="col">Id</th>
                        <th scope="col">News</th>
                    </tr>
                    </thead>
                    <tbody>
                    {#each allPublicNews as prop, index}
                        <tr>
                            <!-- <th scope="row">1</th> -->
                            <td style="text-align: center;">
                                {prop.id}
                                <br>
                                <button class="btn btn-danger" type="button" on:click={deletePublicNews(prop.id)}>Delete</button>
                            </td>
                            <td>
                            <table class="table table-bordered table-hover">
                                <tbody>
                                {#each Object.entries(prop) as item, index2}
                                    {#if item[0] === "id"}

                                    {:else if item[0] == "data" && item[1]}
                                        <tr>
                                            {#each Object.entries(item[1]) as subItem, index3}
                                                <td> ExtraData : {subItem} </td>
                                            {/each}
                                        </tr>
                                    {:else if item[0] == "newsType"}
                                        <tr>
                                            <td> {item[0]} : { findTypeById(item[1])} </td>
                                        </tr>
                                    {:else if item[0] == "newsPriority"}
                                        <tr>
                                            <td> {item[0]} : { findPriorityById(item[1])} </td>
                                        </tr>
                                    {:else if item[0] == "expireAt"}
                                        <tr>
                                            <td> {item[0]} : { moment(new Date(item[1])).from(new Date())} </td>
                                        </tr>
                                    {:else if item[0] == "createdAt"}
                                        <tr>
                                            <td> {item[0]} : { moment(new Date(item[1])).from(new Date())} </td>
                                        </tr>
                                    {:else}
                                        <tr>
                                            <td> {item[0]} : {item[1]} </td>
                                        </tr>
                                    {/if}
                                {/each}
                                </tbody>
                            </table>
                            </td>
                        </tr>
                    {/each}
                    </tbody>
                </table>
                {/if}
            </div>
        </div>

    </div>

<br>
<br>
<br>


<br>

<div class="row justify-content-md-center">

    <!-- Create Public News -->
    <div class="card col-md-8">
        <h5 class="card-header" style="text-align: center;"><h3>Create Public News</h3></h5>

        <div class="card-body">

            <div class="mb-3 input-group">
                <label  class="col-2 col-form-label">NewsType</label>
                <select class="custom-select  form-select" id="inputGroupSelect01" bind:value={publicNewsToCreate.NewsType}>
                    {#each newsTypes as type, index}
                        {#if index == 1}
                            <option selected value="{type[1]}" >{type[0]}</option>
                        {:else}
                            <option value="{type[1]}" >{type[0]}</option>
                        {/if}
                    {/each}
                </select>
            </div>

            {#if newsTypesWithTitleAndDescription.includes(findTypeById(publicNewsToCreate.NewsType)) }
                <div class="mb-3 input-group">
                    <label  class="col-2 col-form-label">Title</label>
                    <input type="text" class="form-control" placeholder="Title" bind:value={publicNewsToCreate.Title}>
                </div>
                <div class="mb-3 input-group">
                    <label  class="col-2 col-form-label">Description</label>
                    <textarea class="form-control" rows="3" bind:value={publicNewsToCreate.Description}></textarea>
                </div>
            {/if}

            <div class="mb-3 input-group">
                <label  class="col-2 col-form-label">ImageURL</label>
                <input type="text" class="form-control" placeholder="ImageURL" bind:value={publicNewsToCreate.ImageURL}>
            </div>
            <div class="mb-3 input-group">
                <label  class="col-2 col-form-label">VideoURL</label>
                <input type="text" class="form-control" placeholder="VideoURL" bind:value={publicNewsToCreate.VideoURL}>
            </div>
            <div class="mb-3 input-group">
                <label  class="col-2 col-form-label">ExternalLinkURL</label>
                <input type="text" class="form-control" placeholder="ExternalLinkURL" bind:value={publicNewsToCreate.ExternalLinkURL}>
            </div>
            <div class="mb-3 input-group">
                <label  class="col-2 col-form-label">BuildVersionLimit</label>
                <input type="text" class="form-control" placeholder="BuildVersionLimit" bind:value={publicNewsToCreate.BuildVersionLimit}>
            </div>
            <div class="mb-3 input-group">
                <label  class="col-2 col-form-label">NewsPriority</label>
                <select class="custom-select  form-select" id="inputGroupSelect02" bind:value={publicNewsToCreate.NewsPriority}>
                    {#each newsPriority as prority, index}
                        {#if index == 1}
                            <option selected value="{prority[1]}" >{prority[0]}</option>
                        {:else}
                            <option value="{prority[1]}" >{prority[0]}</option>
                        {/if}
                    {/each}

                </select>
            </div>
            <div class="mb-3 input-group">
                <label  class="col-2 col-form-label">ExpireAt</label>
                <input type="datetime-local" class="form-control" placeholder="ExpireAt" bind:value={publicNewsToCreate.ExpireAt}>
            </div>
            <div class="mb-3 input-group">
                {#if findTypeById(publicNewsToCreate.NewsType) == newsTypes[0][0]}
                    <label  class="col-2 col-form-label">Version</label>
                    <input type="text" class="form-control" placeholder="1.x.x" bind:value={publicNewsToCreate.Data.version}>
                {:else if findTypeById(publicNewsToCreate.NewsType) == newsTypes[1][0]}
                    <label  class="col-2 col-form-label">Date</label>
                    <input type="text" class="form-control" placeholder="date" bind:value={publicNewsToCreate.Data.date}>
                {:else}
                    <label  class="col-2 col-form-label">Message</label>
                    <input type="text" class="form-control" placeholder="Data" bind:value={publicNewsToCreate.Data.Message}>
                {/if}

            </div>


            <div class="mb-3 input-group">
                <button class="btn btn-danger" type="button" on:click={createPublicNews}>Create</button>
            </div>



        </div>
    </div>



</div>

<br>
<br>
<br>







<style>
    td
    {
        vertical-align: middle;
    }
</style>

<svelte:window on:keydown={onKeyDown} />